import React from 'react';
import { useTranslation } from 'react-i18next';
import { Megaphone } from 'lucide-react';
import PartnershipDetailLayout from './PartnershipDetailLayout';

export default function AffiliatePage() {
  const { t } = useTranslation();
  return (
    <PartnershipDetailLayout
      testId="affiliate-page"
      icon={Megaphone}
      badgeLabel={t('partnership.affiliate.badge')}
      title={t('partnership.affiliate.title')}
      titleAccent={t('partnership.affiliate.titleAccent')}
      intro={t('partnership.affiliate.intro')}
      ctaType="affiliate"
      sections={[
        {
          title: t('partnership.affiliate.s1Title'),
          paragraphs: [
            t('partnership.affiliate.s1P1'),
            t('partnership.affiliate.s1P2'),
          ],
        },
        {
          title: t('partnership.affiliate.s2Title'),
          items: [
            t('partnership.affiliate.s2I1'),
            t('partnership.affiliate.s2I2'),
            t('partnership.affiliate.s2I3'),
            t('partnership.affiliate.s2I4'),
          ],
        },
        {
          title: t('partnership.affiliate.s3Title'),
          paragraphs: [
            t('partnership.affiliate.s3P1'),
            t('partnership.affiliate.s3P2'),
          ],
        },
      ]}
      faq={[
        { q: t('partnership.affiliate.faq1Q'), a: t('partnership.affiliate.faq1A') },
        { q: t('partnership.affiliate.faq2Q'), a: t('partnership.affiliate.faq2A') },
        { q: t('partnership.affiliate.faq3Q'), a: t('partnership.affiliate.faq3A') },
      ]}
    />
  );
}
